<template>
  <div class="filter-inner">
    <div
      class="header-mobile_filter d-flex justify-space-between align-center mb-9"
    >
      <h3 class="h5">Фильтрация</h3>
      <!--{{totalModels}}-->
      <button @click="$emit('closeFilter')" class="d-md-none">
        <i class="icon-close-round fz20"></i>
      </button>
    </div>

    <!-- Производители -->
    <div class="manufacturers-filter filter-overlay">
      <h6 class="filter-subtitle mb-6">Производители</h6>

      <v-input
        autofocus
        not_check
        v-show="showmore.manufacturer"
        v-model="search.manufacturer"
        class="mb-9 search-filter_input"
        color="#fafafa"
      >Поиск
      </v-input>

      <div class="d-flex flex-wrap align-content-start list list_man mb-3" :class="{ show: showmore.manufacturer }">
        <bim-checkbox
          v-for="(man) in manufacturerList"
          :key="man.id"
          :id="man.id"
          class="mb-3 pr-3 checkbox--size checkbox--overflow"
          v-model="man.checked"
          @input="toggleCheckbox('manufacturers')"
          :label="man.text"
          :title="man.text"
        />
      </div>

      <!-- Кнопка "Показать всё" для производителей -->
      <button
        @click="openList('manufacturer', 'list_man')"
        class="show_more link-main mb-9"
      >{{ !showmore.manufacturer ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>

    <!-- ======================================= -->
    <!-- 3d, AR -->
    <div class="optional-filter d-flex flex-wrap align-content-start mb-9">
      <h6 class="filter-subtitle mb-6">Дополнительное</h6>

      <bim-checkbox
        id="view3d"
        class="mb-3 checkbox--size"
        v-model="view3d"
        label="3D-модели"

      />
      <bim-checkbox
        id="viewAR"
        class="checkbox--size"
        v-model="viewAr"
        label="AR-модели"
      />
    </div>

    <!-- ======================================= -->
    <!-- Типы файлов -->
    <div class="file-filter filter-overlay">
      <h6 class="filter-subtitle mb-6">Типы файлов</h6>

      <v-input
        autofocus
        not_check
        v-show="showmore.file"
        v-model="search.file"
        class="mb-9 search-filter_input"
        color="#fafafa"
      >Поиск
      </v-input>

      <div class="d-flex flex-wrap align-content-start list list_file mb-3" :class="{ show: showmore.file }">
        <bim-checkbox
          v-for="(file, i) in fileList"
          :key="file.id + i"
          :id="file.id"
          class="mb-3 checkbox--size checkbox--overflow"
          v-model="file.checked"
          @input="toggleCheckbox('files')"
          :label="file.text"
          :title="file.text"
        />
      </div>
      <!-- Кнопка "Показать всё" для Типы файлов -->
      <button
        @click="openList('file', 'list_file')"
        class="show_more link-main mb-9"
      >{{ !showmore.file ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>

    <!-- ======================================= -->

    <!-- Категория -->
    <div class="category-filter mb-9">
      <h6 class="filter-subtitle mb-6">Категория</h6>

      <bim-select v-model="category" :options="categoriesData" placeholder="Выберите категорию" value-name="id" label-name="text" width="100%"/>
      <!--@change="changeSelect('category')"-->
    </div>

    <!-- ======================================= -->

    <!-- Тип -->
    <div class="type-filter mb-9" v-if="typesData.length">
      <h6 class="filter-subtitle mb-6">Тип</h6>
      <bim-select v-model="type" :options="typesData" placeholder="Выберите тип" value-name="id" label-name="text" width="100%"/>
      <!--@change="changeSelect('type')"-->
    </div>

    <!-- ======================================= -->

    <!-- Класс -->
    <div class="class-filter mb-9" v-if="classesData.length">
      <h6 class="filter-subtitle mb-6">Класс</h6>
      <bim-select v-model="subcategory" :options="classesData" placeholder="Выберите класс" value-name="id" label-name="text" width="100%"/>
      <!--@change="changeSelect('classes')"-->
    </div>
    <!-- ======================================= -->

    <!-- Типы объектов -->
    <div class="objectsType-filter filter-overlay">
      <div class="filter-subtitle-wrap">
        <h6 class="filter-subtitle mb-6">Типы объектов</h6>
      </div>

      <v-input
        autofocus
        not_check
        v-show="showmore.objectsType"
        v-model="search.objectsType"
        class="mb-9 search-filter_input"
        color="#fafafa"
      >Поиск
      </v-input>

      <div class="d-flex flex-wrap align-content-start list list_objectsType mb-3" :class="{ 'show': showmore.objectsType}">
        <bim-checkbox
          v-for="obj in objectsTypeList"
          :key="obj.id"
          :id="obj.id"
          class="mb-3 checkbox--size checkbox--overflow"
          v-model="obj.checked"
          @input="toggleCheckbox('objects')"
          :label="obj.text"
          :title="obj.text"
        />
      </div>
      <!-- Кнопка "Показать всё" для Типы объектов -->
      <button
        @click="openList('objectsType', 'list_objectsType')"
        class="show_more link-main mb-9"
      >{{ !showmore.objectsType ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>

    <!-- ======================================= -->
    <!-- Типы помещений -->
    <div class="aparts-filter filter-overlay">
      <div class="filter-subtitle-wrap">
        <h6 class="filter-subtitle mb-6">Помещения</h6>
      </div>

      <v-input
        autofocus
        not_check
        v-show="showmore.aparts"
        v-model="search.aparts"
        class="mb-9 search-filter_input"
        color="#fafafa"
      >Поиск
      </v-input>

      <div class="d-flex flex-wrap align-content-start list list_aparts mb-3" :class="{ 'show': showmore.aparts}">
        <bim-checkbox
          v-for="(aparts, i) in apartsList"
          :key="aparts.id + i"
          :id="aparts.id"
          class="mb-3 checkbox--size checkbox--overflow"
          v-model="aparts.checked"
          @input="toggleCheckbox('aparts')"
          :label="aparts.text"
          :title="aparts.text"
        />
      </div>

      <!-- Кнопка "Показать всё" для помещения -->
      <button
        @click="openList('aparts', 'list_aparts')"
        class="show_more link-main mb-9"
      >{{ !showmore.aparts ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>

    <!-- ======================================= -->
    <!-- Материалы -->
    <div class="materials-filter filter-overlay">
      <h6 class="filter-subtitle mb-6">Материалы</h6>

      <v-input
        autofocus
        not_check
        v-show="showmore.materials"
        v-model="search.materials"
        class="mb-9 search-filter_input"
        color="#fafafa"
      >Поиск
      </v-input>

      <div class="d-flex flex-wrap align-content-start list list_materials mb-3" :class="{ show: showmore.materials }">
        <bim-checkbox
          v-for="(materials, i) in materialsList"
          :key="materials.id + i"
          :id="materials.id"
          class="mb-3 checkbox--size checkbox--overflow"
          v-model="materials.checked"
          @input="toggleCheckbox('materials')"
          :label="materials.text"
          :title="materials.text"
        />
      </div>
      <!-- Кнопка "Показать всё" для Материалы -->
      <button
        @click="openList('materials', 'list_materials')"
        class="show_more link-main mb-4"
      >{{ !showmore.materials ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>


    <!-- <bim-button label="Регионы" color="gray" width="100%" class="mb-6" @click="openModalRegions = true" /> -->
    <bim-button size="l" width="100%" class="nowrap w-100 d-md-none d-flex" @click="closeFilter()">Применить</bim-button>

    <bim-button
      color="gray"
      size="l"
      background="#f6f6f6"
      width="100%"
      class="clear-filter-btn nowrap w-100 mt-6"
      @click="filterReset"
    >Очистить фильтры
    </bim-button>

    <popup v-model="openModalRegions" width="90%" title="Фильтр по регионам">
      <div class="regions-modal">
        <!--<Regions v-model="checkedRegions" :checked="checkedRegionsList"/>-->
      </div>
      <div class="d-flex mt-6 buttons-modal">
        <bim-button class="mr-6 ml-auto" color="gray" label="Отмена" @click="openModalRegions = false"/>
        <bim-button label="Применить" @click="acceptRegionsFilter"/>
      </div>
    </popup>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import bimSelect from '@bimlib/components/bimSelect'
import popup from '@bimlib/components/bimPopup'
import bimCheckbox from '@bimlib/components/bimCheckbox'
import Regions from '@/athoms/Regions'

import { mapActions, mapGetters } from 'vuex'

function byField (field) {
  return (a, b) => a[field] < b[field] ? 1 : a[field] === b[field] ? 0 : -1
}

export default {
  components: {
    VueSlider, bimSelect, popup, Regions, bimCheckbox,
  },
  data () {
    return {
      openModalRegions: false,
      checkedRegions: [],
      search: {
        manufacturer: '',
        file: '',
        objectsType: '',
        aparts: '',
        materials: '',
      },
      showmore: {
        manufacturer: false,
        file: false,
        objectsType: false,
        aparts: false,
        materials: false,
      },
      typeList: [],
      classesList: [],
    }
  },
  async created () {
    await this.locationQueryOnLoad(true)
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      checkedRegionsList: 'checkedRegions',
    }),
    ...mapGetters([
      'totalModels',
      'categoriesData',
      'typesData',
      'classesData',
      'categoriesFilter',
      'typesFilter',
      'classesFilter',
    ]),
    category: {
      get () {
        return this.$store.getters.categoriesFilter
      },
      set (val) {
        if (val && this.categoriesFilter !== val) {
          // this.$store.commit('categoriesFilteres', val)
          this.setCategories(val)
        }
      },
    },
    type: {
      get () {
        return this.typesFilter
      },
      set (val) {
        if (val && this.typesFilter !== val) {
          // this.$store.commit('typesFilteres', val)
          this.setTypes(val)
        }
        // this.setTypes(val)
      },
    },
    subcategory: {
      get () {
        return this.classesFilter
      },
      set (val) {
        if (val && this.classesFilter !== val) {
          // this.$store.commit('classesFilteres', val)
          this.setClasses(val)
        }

        // this.setClasses(val)
      },
    },
    viewAr: {
      get () {
        let viewAr = this.$store.getters.viewArFilter
        if (typeof viewAr === 'string' && viewAr === 'true') { viewAr = true }
        return viewAr
      },
      set () { this.toggleCheckbox('viewAr') },
    },
    view3d: {
      get () {
        let view3d = this.$store.getters.view3dFilter
        if (typeof view3d === 'string' && view3d === 'true') { view3d = true }
        return view3d
      },
      set () { this.toggleCheckbox('view3d') },
    },
    /**
     * Получаем список производителей.
     * Список фильтруется
     * @return {array} - массив производителей
     */
    manufacturerList () {
      let arr = this.$store.getters.manufacturersDataPaidTariff
      // arr.find(el => el.id == '941')
      arr = arr.sort(byField('checked'))
      return arr.filter(item => {
        if (!item.checked) { // если элемент не чекнутый, то фильтруется
          return item.text.toLowerCase().indexOf(this.search.manufacturer.toLowerCase()) !== -1
        } else return item.text.toLowerCase() // если элемент чекнутый, то остается вверху списка
      })
    },
    /**
     * Получаем список типов файлов.
     * Список фильтруется
     * @return {array} - массив типов
     */
    fileList () {
      let arr = this.$store.getters.filesData
      arr = arr.sort(byField('checked'))

      return arr.filter(item =>
        !item.checked
          ? new RegExp(`^${this.search.file}`).exec(item.id)
          : item.id.toLowerCase(),
      )
    },
    /**
     * Получаем список типов объектов.
     * Список фильтруется
     * @return {array} - массив типов объектов
     */
    objectsTypeList () {
      let arr = this.$store.getters.objectsData
      arr = arr.sort(byField('checked'))

      return arr.filter(item => {
        if (item.checked === false) {
          return (
            item.text
              .toLowerCase()
              .indexOf(this.search.objectsType.toLowerCase()) !== -1
          )
        } else return item.text.toLowerCase()
      })
    },
    /**
     * Получаем список зданий.
     * Список фильтруется
     * @return {array} - массив зданий
     */
    apartsList () {
      let arr = this.$store.getters.apartsData
      arr = arr.sort(byField('checked'))

      return arr.filter(item => {
        if (item.checked === false) {
          return (
            item.text
              .toLowerCase()
              .indexOf(this.search.aparts.toLowerCase()) !== -1
          )
        } else return item.text.toLowerCase()
      })
    },
    /**
     * Получаем список зданий.
     * Список фильтруется
     * @return {array} - массив зданий
     */
    materialsList () {
      let arr = this.$store.getters.materialsData
      arr = arr.sort(byField('checked'))
      return arr.filter(item => {
        if (item.checked === false) {
          return (
            item.text
              .toLowerCase()
              .indexOf(this.search.materials.toLowerCase()) !== -1
          )
        } else return item.text.toLowerCase()
      })
    },
  },
  methods: {
    ...mapActions([
      'setCategories',
      'setTypes',
      'setClasses',
      'locationQueryOnLoad',
      'setQueryParams',
      'toggleCheckbox',

      'resetFilter',
      'getCheckedRegions',
    ]),
    /**
     * Применение фильтра регионов
     */
    acceptRegionsFilter () {
      if (typeof this.checkedRegions === 'object') {
        const checked = this.checkedRegions.map(el => el.id)
        this.setQueryParams({ nameQuery: 'regions', arr: checked })
        this.getCheckedRegions(checked)
        this.openModalRegions = false
      }
    },
    closeFilter () {
      this.$emit('closeFilter')
      window.scrollTo({
        top: 66,
        behavior: 'smooth',
      })
    },
    /**
     * Сброс всех значений фильтра
     */
    async filterReset () {
      await this.resetFilter('all')

      for (let key in this.showmore) {
        this.showmore[key] = false
      }
      for (let key in this.search) {
        this.search[key] = ''
      }
      const lists = document.querySelectorAll('.list')
      lists.forEach(list => list.scrollTo({ top: 0 }))
    },
    /**
     * Открывает полный список фильтра
     * @param {string} listName - название списка, который нужно раскрыть
     * @param {string} classNameList - название класса списка который нужно скроллить
     */
    async openList (listName, classNameList) {
      this.showmore[listName] = !this.showmore[listName]
      if (!this.showmore[listName]) {
        this.search[listName] = ''
        document.querySelector(`.${classNameList}`).scrollTo({
          top: 0,
          // behavior: "smooth"
        })
      }
    },
    /**
     * Контроллер для вызова функций в зависимости от выбранного селекта. Для разделов, категорий, подкатегорий.
     */
    // changeSelect (select) {
    //   switch (select) {
    //     case 'category':
    //       this.setCategories(this.category)
    //       break
    //     case 'type':
    //       this.setTypes(this.type)
    //       break
    //     case 'classes':
    //       this.setClasses(this.subcategory)
    //       break
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.filter-more {
  &--cut {
    max-height    : 0;
    overflow      : hidden;
    margin-bottom : 10px;
  }
}

.vue-slider {
  max-width : calc(100% - 18px);
}

.filter-inner {
  margin-top : 10px;
}

.search-filter_input input {
  background-color : #fafafa;
}

.penoplex-btn {
  display       : flex;
  width         : 100%;
  padding       : 7px 8px;
  height        : 34px;
  color         : $text-main-2;
  font-size     : 14px;
  border        : 1px dashed rgba($text-main-2, 0.25);
  border-radius : 4px;

  &--active {
    color  : $active;
    cursor : default;
  }
}

.filter-subtitle {
  font-size   : 14px;
  font-weight : bold;
}

.filter-subtitle-wrap {
  display         : flex;
  justify-content : space-between;

  i {
    height     : 8px;
    margin-top : 4px;
    font-size  : 8px;
  }

  &--more {
    cursor : pointer;

    h6 {
      font-size : 15px;
    }
  }

  &--active {
    i {
      transform : rotate(180deg);
    }
  }
}

// Списки
.list {
  overflow-y : hidden;
  max-height : 136px;
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    max-height : 85px;
  }

  &.show {
    max-height : 240px;
    overflow-y : auto;
  }
}

// Кастомный скроллбар для списков
.list::-webkit-scrollbar-track {
  background-color : $soft;
  border-radius    : 4px;
}

.list::-webkit-scrollbar {
  width : 8px;
}

.list::-webkit-scrollbar-thumb {
  background-color : $text-soft-light;
  border-radius    : 4px;
}

.list:hover::-webkit-scrollbar-thumb {
  background-color : darken($text-soft-light, 5%);
}

// Список производителей
.list_man {
  max-height : 136px;

  &.show {
    max-height : 248px;
  }
}

// Список помещений (высота блока)
.list_aparts {
  max-height : 132px;

  &--cut {
    height : 0 !important;
  }
}

// Список файлов
.list_file {
  max-height : 168px;

  &.show {
    max-height : 280px;
  }
}

// Список зданий (высота блока в закрытом и открытом(.show) состоянии)
.list_objectsType {
  max-height : 148px;

  &.show {
    max-height : 350px;
  }

  &--cut {
    height : 0;
  }
}

// Список помещений в открытом состоянии
.list_aparts.show {
  max-height : 310px;
}

// Список материалов
.list_materials {
  max-height : 148px;
}

.filter-size-wrap {
  max-height : 666px;

  &--cut {
    max-height : 0;
    overflow   : hidden;
  }
}

.list {
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    max-height : 85px;
  }

  .checkbox-wrapper {
    font-size : 14px;
  }
}

.checkbox--size {
  flex        : 0 0 100%;
  align-items : flex-start;
}

.checkbox--overflow {
  width: 100%;
  word-break: normal;
  white-space: nowrap;
  overflow: hidden;

  &::v-deep .checkbox__label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.show_more {
  font-size : 12px;
  color     : $active;
}

.filter-clear {
  display          : flex;
  justify-content  : center;
  align-items      : center;
  height           : 54px;
  background-color : #f6f6f6;
  border           : solid 1px #e6e6e6;
  border-radius    : 3px;
  color            : #4d4d4d;
  font-size        : 14px;
  font-weight      : bold;

  &:hover {
    opacity : 0.7;
  }
}

/* Переназначение позиции у чекбоксов в списках зданий, помещений и материалов
(из-за того что есть позиции в несколько строк) */
// .objectsType_checkbox,
// .aparts_checkbox,
// .materials_checkbox {
//   label:before,
//   label:after {
//     top: 11px !important;
//   }
// }

// Кастомизация точек у ренж инпутов
.custom-dot {
  box-sizing       : border-box;
  width            : 18px;
  height           : 18px;
  // box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.13);
  border           : solid 4px $active;
  border-radius    : 50%;
  background-color : #ffffff;

  &:active {
    background-color : $active;
  }
}

// Добавление полоски между инпутами
.range_text-block {
  position : relative;

  &:before {
    content          : "";
    display          : inline-block;
    position         : absolute;
    width            : 50%;
    height           : 2px;
    top              : 50%;
    left             : 50%;
    transform        : translate(-50%, -50%);
    background-color : $filter-border;
    z-index          : 1;
  }
}

// Кастомизация инпутов со значениями ренжей
.slider_input {
  display          : inline-block;
  max-width        : 49%;
  width            : 96px;
  min-width        : 44%;
  height           : 44px;
  border-radius    : 5px;
  border           : solid 1.5px $filter-border;
  text-align       : center;
  z-index          : 2;
  background-color : $bg-main;
  background-image : -webkit-gradient(
      linear,
      0% 0%,
      0% 100%,
      from(hsla(0, 0%, 100%, 0)),
      to(hsla(0, 0%, 100%, 0))
  );
  background-image : -webkit-linear-gradient(
      hsla(0, 0%, 100%, 0),
      hsla(0, 0%, 100%, 0)
  );
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    width : 147px;
  }

  &_active {
    border-color : $active;
  }
}

// Анимация появления (инпутов в списках)
.fade-enter-active,
.fade-leave-active {
  transition : opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity : 0;
}

.regions-modal {
  width          : 500px;
  max-width      : 100%;
  padding-bottom : 90px;
}

.buttons-modal {
  width            : calc(100% - 24px);
  position         : absolute;
  bottom           : 0;
  left             : 0;
  background-color : $white-color;
  padding          : 14px 0 24px 24px;
}

.clear-filter-btn {
  border : 1px solid $white-color-500 !important;
}
</style>
